import BaselineProphyQuestionnaire from '@/store/questionnaires/questionnaireConfig/BaselineProphyQuestionnaire'
import RecurringProphyQuestionnaire from '@/store/questionnaires/questionnaireConfig/RecurringProphyQuestionnaire'

// this class automatically recurring medication studies
// NOTE: study creation, matching questionnaire to study and results config still need to be done manually in backend


export default class RecurringProphyStudy {
  constructor (options) {
    this.studyName = options.molecule.toLowerCase() + '-internal'
    this.canJoin = true
    this.canSeeResults = true
    this.category = 'Medication'
    this.internalResultsConfig = false
    this.hasMultipleLanguages = false
    this.molecule = options.molecule
    this.header = options.molecule
    this.subheader = options.smallText
    this.dosageOptions = options.dosageOptions
    this.baselineFormId = 'baselineProphy' + options.molecule
    this.baselineQuestionnaire = new BaselineProphyQuestionnaire(options.molecule, options.dosageOptions)
    this.recurringFormId = 'recurringProphy' + options.molecule
    this.recurringQuestionnaire = new RecurringProphyQuestionnaire(options.molecule, options.dosageOptions)
  }
}



// WEBPACK FOOTER //
// ./src/store/recurring/studyConfig/RecurringProphyStudy.js